<template>
  <div>
    <el-dialog
      title=""
      :visible="visibleForm"
      width="50%"
      :before-close="cloneDialog"
    >
      <div slot="title" class="apply_title">{{ $t('applyForm.title')}}</div>
      <div>
        <el-form
          :label-position="'right'"
          :rules="applyFormRules"
          label-width="auto"
          :model="applyForm"
          ref="apply_form"
        >
          <el-form-item :label="$t('applyForm.journalName')">
            <el-input v-model="applyForm.journalName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyForm.issn')">
            <el-input v-model="applyForm.issn"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyForm.webSite')">
            <el-input v-model="applyForm.webSite"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyForm.contact')" prop="contact">
            <el-input v-model="applyForm.contact"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyForm.contactInformation')" prop="contactInformation">
            <el-input v-model="applyForm.contactInformation"></el-input>
          </el-form-item>
          <el-form-item :label="$t('applyForm.request')">
            <el-input type="textarea" v-model="applyForm.request"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="apply_btn" @click="onSubmit">{{
          $t("form.submitBtn")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { postForm } from "@/api/form/form.js";

export default {
  data() {
    return {
      visibleForm: false,
      applyForm: {
        journalName: "",
        issn: "",
        webSite: "",
        contact: "",
        contactInformation: "",
        request: "",
      },
      applyFormRules: {
        contact: [
          { required: true, trigger: "blur", message: this.$t('formRules.name') },
          {
            min: 2,
            max: 20,
            trigger: "blur",
            message: this.$t('formRules.nameFormat')
          },
        ],
        contactInformation: [
          { required: true, trigger: "blur", message: this.$t('formRules.phoneEmail') },
          {
            validator: (rule, value, callback) => {
              const phoneRegex = /^1[3-9]\d{9}$/; // 简单的中国大陆手机号正则
              const emailRegex =
                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // 简单的邮箱正则
              if (phoneRegex.test(value) || emailRegex.test(value)) {
                callback();
              } else {
                callback(new Error(this.$t('formRules.phoneEmailFormat')));
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.apply_form.validate((valid) => {
        if (valid) {
          postForm(this.applyForm).then((response) => {
            if (response.code == 200) {
              this.$message({
                type: "success",
                message: this.$t('messagePrompt.success'),
              });
              this.resetForm();
            }
          });
          this.visibleForm = false;
        } else {
          return false;
        }
      });
    },
    openDialog() {
      this.visibleForm = true;
    },
    cloneDialog() {
      this.resetForm();
      this.$refs.apply_form.resetFields();
      this.visibleForm = false;
    },
    resetForm() {
      this.applyForm = Object.keys(this.applyForm).reduce((acc, cur) => {
        acc[cur] = "";
        return acc;
      }, {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
